var glyph = {
  "display": "inline-block",
  "lineHeight": "1",
  "verticalAlign": "middle",
  "&::before": {
    "WebkitFontSmoothing": "antialiased",
    "WebkitTextStroke": "0",
    "MozOsxFontSmoothing": "grayscale",
    "WebkitBackfaceVisibility": "hidden",
    "backfaceVisibility": "hidden",
    "display": "block",
    "fontFamily": "\"dls-icons-2.25.0\"",
    "fontStyle": "normal",
    "fontWeight": "normal",
    "fontVariant": "normal",
    "textTransform": "none",
    "lineHeight": "1",
    "letterSpacing": "0",
    "position": "relative",
    "speak": "none",
    "verticalAlign": "middle",
    "fontSize": "1rem"
  },
  "&:hover": {
    "textDecoration": "none"
  },
  "fontSize": "1rem"
};

export { glyph };
